import { render } from "./SuplenciasSection.vue?vue&type=template&id=1651716a&scoped=true"
import script from "./SuplenciasSection.vue?vue&type=script&lang=js"
export * from "./SuplenciasSection.vue?vue&type=script&lang=js"

import "./SuplenciasSection.vue?vue&type=style&index=0&id=1651716a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1651716a"]])

export default __exports__